export const Text = {
  baseStyle: {
    color: 'font-1',
  },
  sizes: { },
}
